/**
 * @param tableQuery table Query
 */
function isFolderSearch(tableQuery) {
    if (tableQuery.type != 1 /* Search */) {
        return false;
    }
    var currentSearchScope = tableQuery.searchScope;
    var foldersSearchScopeKinds = [
        "PrimaryMailbox" /* PrimaryMailbox */,
        "ArchiveMailbox" /* ArchiveMailbox */,
        "SharedFolders" /* SharedFolders */,
    ];
    // Return true only if the table query's search scope type
    // is either primary mailbox or archive mailbox or shared folders
    return foldersSearchScopeKinds.indexOf(currentSearchScope.kind) > -1;
}
/**
 * @param tableView table View
 * @returns folderId based on the type and search scope of the table query
 */
export default function getFolderIdFromTableView(tableView) {
    var tableQuery = tableView.tableQuery;
    if (tableQuery.type === 0 /* Folder */) {
        return tableQuery.folderId;
    }
    else if (isFolderSearch(tableQuery)) {
        var folderSearchScope = tableQuery
            .searchScope;
        return folderSearchScope.folderId;
    }
    return null;
}
//# sourceMappingURL=getFolderIdFromTableView.js.map